import { z } from 'zod'
import { USER_ROLES } from '../enums'

export const sessionUserSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string(),
  role: z.enum(USER_ROLES),
})

export type SessionUser = z.infer<typeof sessionUserSchema>

/** Development-only sign-in, so the app is usable before Google credentials exist. */
export const devLoginSchema = z.object({
  email: z.string().trim().email('כתובת דואר אלקטרוני לא תקינה'),
})

export type DevLoginInput = z.infer<typeof devLoginSchema>
